module.exports = __webpack_public_path__ + "static/media/read_content_aloud_malayalam.5332242a.mp3";